import { createContext, useContext, useState } from "react";
import { Requester } from "./Requester";
import { jsx as _jsx } from "react/jsx-runtime";
const RequestContext = /*#__PURE__*/createContext({
  pending: false,
  requester: null,
  requestError: null,
  setRequestError: null
});
function RequestProvider({
  children
}) {
  const [pending, setPending] = useState(false);
  const [requestError, setRequestError] = useState(null);
  const requester = new Requester(setPending, setRequestError);
  const value = {
    pending,
    requester,
    setRequestError,
    requestError
  };
  return /*#__PURE__*/_jsx(RequestContext.Provider, {
    value: value,
    children: children
  });
}
function useRequest() {
  return useContext(RequestContext);
}
export { RequestProvider, useRequest };